import styled, { css } from 'styled-components';
import { layout, LayoutProps } from 'styled-system';
import { motion } from 'framer-motion';

import { Variant } from './types';

export const Container = styled(motion.div)<{ variant: Variant } & LayoutProps>`
  overscroll-behavior: contain;
  max-height: 100svh;
  display: flex;
  justify-content: center;
  ${layout};

  ${({ variant }) => {
    if (variant === 'layer')
      return css`
        width: 100%;
        height: 100%;
      `;
    return css`
      min-width: 600px;
      max-width: 800px;
    `;
  }};
`;
